<template>
  <v-container class="py-0">
    <v-row>
      <v-col>
        <div class="text-center display-1 font-weight-normal mb-6">
          Vamos começar preenchendo as informações gerais do cálculo
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <validation-provider v-slot="{ errors, valid }" rules="required">
          <validation-helper
            :interceptor="valid"
            @isValid="$emit('step-observer-nome', { step: 'nome', complete: $event })"
          />
          <v-text-field :error-messages="errors" label="Nome do Cálculo" v-model="nome">
          </v-text-field>
        </validation-provider>
      </v-col>
      <v-col>
        <validation-provider v-slot="{ errors, valid }" rules="required">
          <validation-helper
            :interceptor="valid"
            @isValid="
              $emit('step-observer-empresa', { step: 'empresa', complete: $event })
            "
          />
          <v-autocomplete
            v-model="empresaSelecionada"
            :error-messages="errors"
            :items="itemsEmpresa"
            item-value="execucao_id"
            item-text="abreviacao"
            label="Empresa"
            placeholder="Selecione a Empresa"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <validation-provider v-slot="{ errors, valid }" rules="required">
          <validation-helper
            :interceptor="valid"
            @isValid="
              $emit('step-observer-data-inicio', {
                step: 'data-inicio',
                complete: $event,
              })
            "
          />
          <date-picker
            v-model="dataInicialAnalise"
            :showIcon="false"
            label="Início Incremental"
            type="date"
            :outlined="true"
            rules="required|min:7"
          />
        </validation-provider>
      </v-col>
      <v-col>
        <validation-provider v-slot="{ errors, valid }" rules="required">
          <validation-helper
            :interceptor="valid"
            @isValid="
              $emit('step-observer-data-final', {
                step: 'data-final',
                complete: $event,
              })
            "
          />
          <date-picker
            v-model="dataFinalAnalise"
            :showIcon="false"
            label="Fim Incremental"
            type="date"
            :outlined="true"
            rules="required|min:7"
          />
        </validation-provider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BulldozerrService from "@/services/BulldozerrService.js";

export default {
  components: {
    DatePicker: () => import("@/components/general/DatePicker.vue"),
    ValidationHelper: () => import("@/components/general/ValidationHelper.vue"),
  },

  data: () => ({
    nome: "",
    itemsEmpresa: [],
    empresaSelecionada: null,
    dataInicialAnalise: null,
    dataFinalAnalise: null
  }),

  mounted() {
    this.getEmpresas();
  },

  methods: {
    getEmpresas() {
      BulldozerrService.getEmpresas()
        .then((response) => (this.itemsEmpresa = response.data.empresas))
        .catch((err) => {
          console.error(err);
          this.$toast.error("Ocorreu um erro ao recuperar os dados das empresas.");
        });
    },

    exportData() {
      return {
        nome: this.nome,
        dataInicialAnalise: this.dataInicialAnalise,
        dataFinalAnalise: this.dataFinalAnalise,
        empresaSelecionada: this.empresaSelecionada,
      };
    }
  }
};
</script>
